import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";

const emptyItem = (fields) => Object.fromEntries(fields.map((f) => [f.key, f.type === "lines" ? [] : ""]));

export const ListField = ({ field, value, onChange, testId, renderField }) => {
  const items = Array.isArray(value) ? value : [];
  const update = (i, v) => onChange(items.map((it, j) => (j === i ? v : it)));
  const move = (i, d) => {
    const next = [...items];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onChange(next);
  };
  return (
    <div className="space-y-3">
      {items.map((it, i) => (
        <div key={i} className="rounded-lg border border-slate-800 bg-slate-950/60 p-3" data-testid={`${testId}-item-${i}`}>
          <div className="mb-2 flex items-center justify-between font-mono text-[11px] text-slate-500">
            <span>#{i + 1}</span>
            <div className="flex gap-1">
              <button type="button" disabled={i === 0} onClick={() => move(i, -1)} className="admin-icon-btn" aria-label="Subir"><ArrowUp size={13} /></button>
              <button type="button" disabled={i === items.length - 1} onClick={() => move(i, 1)} className="admin-icon-btn" aria-label="Bajar"><ArrowDown size={13} /></button>
              <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} className="admin-icon-btn hover:text-red-400" aria-label="Eliminar" data-testid={`${testId}-remove-${i}`}><Trash2 size={13} /></button>
            </div>
          </div>
          <div className="space-y-3">
            {field.fields.map((sub) =>
              renderField({ key: sub.key, field: sub, value: it[sub.key], onChange: (v) => update(i, { ...it, [sub.key]: v }), testId: `${testId}-${i}-${sub.key}` })
            )}
          </div>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...items, emptyItem(field.fields)])} className="admin-btn" data-testid={`${testId}-add`}>
        <Plus size={14} /> Agregar elemento
      </button>
    </div>
  );
};

export default ListField;
